<template>
  <div class="manual-amount-block">
    <v-slider
      :value="safeValue"
      :min="min"
      :max="max"
      :step="step"
      color="secondary"
      track-color="grey lighten-2"
      hide-details
      class="manual-amount-slider"
      @input="$emit('input', $event)"
    ></v-slider>
    <div
      class="manual-amount-labels d-flex justify-space-between align-center position-relative"
    >
      <span class="text-caption grey--text manual-amount-edge">{{ min }}</span>
      <v-chip
        color="grey lighten-4"
        small
        rounded
        dense
        class="manual-amount-value position-absolute font-weight-bold"
      >
        {{ safeValue > 0 ? "+" : "" }}{{ safeValue }} {{ unit }}
      </v-chip>
      <span class="text-caption grey--text manual-amount-edge">
        {{ max > 0 ? "+" : "" }}{{ max }}
      </span>
    </div>
  </div>
</template>

<script>
/**
 * Importe del ajuste manual: slider con el valor en un chip centrado y los
 * extremos del rango a los lados.
 *
 * Vive en el kit de campos aunque no sea una condición: la tarjeta de acción
 * lo pinta en dos sitios —el bloque de valor único y el slot de cada ruta— y
 * antes eran dos copias del mismo marcado.
 */
export default {
  name: "a-pricing-strategy-rule-type-condition-field-amount-slider",
  props: {
    value: { type: Number, default: 0 },
    min: { type: Number, default: -50 },
    max: { type: Number, default: 50 },
    step: { type: Number, default: 1 },
    unit: { type: String, default: "€" }
  },
  computed: {
    // El bucket puede traer null (campo vaciado en otro control); el slider
    // no sabe qué hacer con eso y pintaría el pulgar en el mínimo.
    safeValue() {
      return this.value == null ? 0 : this.value;
    }
  }
};
</script>

<style scoped lang="scss">
.manual-amount-labels {
  min-height: 28px;
  margin-top: -2px;
}
.manual-amount-edge {
  font-size: 9px;
  z-index: 0;
}
.manual-amount-value {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
::v-deep .v-input--slider {
  margin-top: 2px;
}
::v-deep .v-input {
  font-size: 13px;
}
</style>
